
import briggite from '../assets/img/briggite2.png';
import doublePedestal from '../assets/img/doublepedestal2.png';
import irishCoffinBox from '../assets/img/irishcoffinbox2.png';
import metropolisM from '../assets/img/metropolism2.png';
import mushroom from '../assets/img/mushroom2.png';
import hybridSystem from '../assets/img/new/air-n-glycol-beer-towers.png';
import beerLineBg from '../assets/img/new/beerline_draft2.jpg';
import doudblePedestal from '../assets/img/new/direct-draw-system.png';
import glycolCoolingSystem from '../assets/img/new/glycol-cooled-system.png';
import zeus from '../assets/img/zeus2.png';

export const backgrounds = {
    beerline: beerLineBg
}

export const title = 'Mr-Draft';

export const links = {
    nav: [
        {
            value: 'aboutId',
            label: 'about',
            linkRef: '/about',
        },
        {
            value: 'beerLineId',
            label: 'beer line cleaning',
            linkRef: '/beerline',
        },
        {
            value: 'draftSystemId',
            label: 'draft system installations',
            linkRef: '/systems',
        },
        {
            value: 'buildTowersId',
            label: 'custom build towers',
            linkRef: '/buildtowers',
        },
        {
            value: 'contactId',
            label: 'contact',
            linkRef: '/contact',
        }
    ]
}
export const draftServices = [
    {
        value: 'draftSystemId',
        label: "Draft System Installations",
        linkRef: '/systems'
    },
    {
        value: 'buildTowersId',
        label: "Custom Build towers",
        linkRef: '/buildtowers'
    },
    {
        value: 'troubleshootingNRepairId',
        label: "Troubleshooting & Repair",
        linkRef: '/404'
    },
    {
        value: 'beerLineCleaningId',
        label: "Beer Line Cleaning",
        linkRef: '/beerline'
    },
    {
        value: 'emergencyServiceId',
        label: "Emergency Service",
        linkRef: '/404'
    },
    {
        value: 'famOperatedId',
        label: "Family owned and Operated",
        linkRef: '/404'
    }
]

export const draftSystems = [
    {
        id: 'directDrawSystemId',
        title: "Direct Draw System",
        description: 'This system typically uses a single beer line connected to a keg that is stored inside a refrigerated unit located directly beneath the tap. Direct draw systems typically use a standard CO2 gas cylinder to dispense the beer.',
        imgSrc: doudblePedestal,
    },
    {
        id: 'longDrawSystemId',
        title: "Long Draw System",
        description: 'This system involves running beer lines from a refrigerated room or walk-in cooler to the bar. The lines can be quite long and require special insulation to prevent foaming or warming of the beer. Long draw systems typically use a glycol cooling system or an air compressor to dispense the beer.',
        imgSrc: doublePedestal,
    },
    {
        id: 'glycolCoolingSystemId',
        title: "Glycol Cooling System",
        description: 'This system uses a mixture of water and glycol to cool the beer as it travels through the lines. The glycol mixture is kept in a separate refrigeration unit and pumped through the beer lines to keep the beer at a consistent temperature. Glycol cooling systems typically use a glycol chiller, a CO2 gas cylinder, and a beer gas regulator to dispense the beer.',
        imgSrc: glycolCoolingSystem,
    },
    {
        id: 'hybridSystemId',
        title: "Hybrid System",
        description: 'This system combines elements of both the direct draw and long draw systems. It uses a refrigerated unit at the bar, but the kegs are kept in a separate cooler or walk-in. Hybrid systems typically use a glycol cooling system or a standard CO2 gas cylinder to dispense the beer.',
        imgSrc: hybridSystem,
    },
]

export const buildTowers = [
    {
        id: 'doublePedestalId',
        title: 'Double Pedestal',
        description: 'Clean, contemporary styling with up to 12 faucets for draft beer dispensing. Available in either PVD Brass or Polished Stainless Steel. Air or glycol cooled.',
        imgSrc: doublePedestal,
    },
    {
        id: 'brigitteId',
        title: 'Brigitte',
        description: 'The grandeur and imposing dignity of the Brigitte tower create an excellent platform for multi-keg draft sales.',
        imgSrc: briggite,
    },
    {
        id: 'irishCoffinBoxId',
        title: 'Irish Coffin Box',
        description: 'The authentic look of an Irish Pub. Handcrafted solid oak tower mounts to the top of your bar with integrated drip tray. Custom engraving available. Available in 6 to 12 faucets.',
        imgSrc: irishCoffinBox,
    },
    {
        id: 'metropolisM',
        title: "Metropolis 'M'",
        description: "Dramatic art deco look! 'M' shaped draft beer dispenser tower available in 20 and 24 faucet configurations. PVD Brass or Polished Stainless Steel. Glycol cooled only.",
        imgSrc: metropolisM,
    },
    {
        id: 'mushroomId',
        title: 'Mushroom',
        description: "Traditional mushroom beer dispensing towers with up to 6 faucets. These towers have a 7-1/2'' base, and are available in either chrome or brass.",
        imgSrc: mushroom,
    },
    {
        id: 'zeusId',
        title: 'Zeus',
        description: 'The drama of clean Italian design, accented with a colored ceramic base. Available in brass or chrome finishes with glycol cooling.',
        imgSrc: zeus,
    }
]